
import { Vue, Component, Emit, Prop, Ref } from "vue-property-decorator";
import MapApp from "@/plugin/gis-viewer/MapAppArcgis3D";
import MiniMapArcgisThreeD from "@/plugin/gis-viewer/widgets/MiniMap/arcgis/MiniMap_ArcGIS3D.vue";
import CrossRegionMenu from "@/plugin/gis-viewer/widgets/CrossRegion/CrossRegionMenu.vue";
import CrossInfoPanel from "@/plugin/gis-viewer/widgets/MapCenterCheck/arcgis/CrossInfoPanel.vue";

import {
  IMapContainer,
  IOverlayParameter,
  IHeatParameter,
  IOverlayClusterParameter,
  IOverlayDelete,
  ILayerConfig,
  IPointGeometry,
  ICenterLevel,
  IFindParameter,
  IResult,
  IDistrictParameter,
  IStreetParameter,
  IRouteParameter,
  IHeatImageParameter,
  IGeometrySearchParameter,
  ICustomTip,
  ISelectRouteParam,
  ISelectRouteResult,
  IDrawOverlays,
  ISelectRouteHitTest,
  IDefinitionParameter,
  ITrackParameter,
  ISumoConnectInfo,
  ISignalPhaseInfo,
  ICrossRegionInfo,
  IPopUpTemplate,
  IPosition,
  ICamera,
  ICrossCamera,
  ICrossInView,
  IPassagewaysParam,
  ILaneSignalPhaseInfo,
  IMapLevel,
  IShowSelectedLaneParam,
  IComponentOverlayParam,
  IDynamicLayerDataParams,
} from "@/types/map";

@Component({
  name: "MapContainerArcgisThreeD",
  components: {
    MiniMapArcgisThreeD,
    CrossRegionMenu,
    CrossInfoPanel,
  },
})
export default class MapContainerArcgis3D extends Vue implements IMapContainer {
  private mapApp!: MapApp;

  private mapId: string = "divArcGISMap3D" + (Math.random() * 10000).toFixed(0);
  //地图配置
  @Prop({ type: Object }) readonly mapConfig!: any;

  private showWidgets: string[] = [];

  get widgetNames() {
    return this.mapConfig.widgets
      ? this.mapConfig.widgets.map((widget: any) => widget.name)
      : [];
  }

  get widgetConfig() {
    const self = this;
    return function (name: string) {
      if (!self.mapConfig.widgets) {
        return {};
      } else {
        const widget = self.mapConfig.widgets.find(
          (widget: any) => widget.name === name
        );
        return widget ? widget.config : {};
      }
    };
  }

  get view() {
    return this.mapApp.view;
  }

  @Ref() readonly miniMap!: MiniMapArcgisThreeD;

  private crossInfoPanelInfos?: Array<{
    id: string;
    position: number[];
    positionCoor: number[];
    videoUrl: string;
  }> = [];

  @Emit("map-loaded")
  async mounted() {
    this.mapApp = new MapApp();
    await this.mapApp.initialize(this.mapConfig, this.mapId);

    this.mapApp.showGisDeviceInfo = this.showGisDeviceInfo;
    this.mapApp.mouseGisDeviceInfo = this.mouseGisDeviceInfo;
    this.mapApp.mapClick = this.mapClick;
    this.mapApp.mapFocused = this.mapFocused;
    this.mapApp.mapInteractive = this.mapInteractive;
    this.mapApp.requestNextSignalPhase = this.requestNextSignalPhase;
    this.mapApp.phaseChanged = this.phaseChanged;
    this.mapApp.crossInfoPanelInfos = this.crossInfoPanelInfos;

    if (this.mapConfig.widgets) {
      this.mapConfig.widgets.forEach((widget: any) => {
        if (widget.visible !== false) {
          this.showWidgets.push(widget.name);
        }
      }, this);
    }
    await this.miniMap?.initialize(
      this.mapApp,
      this.showWidgets.includes("MiniMap"),
      this.widgetConfig("MiniMap")
    );
  }

  @Emit("layer-loaded")
  public layerLoaded() {}

  @Emit("map-click")
  public mapClick(point: object) {
    this.hideRegionCrossMenu();
  }

  private showCrossRegionMenu = false;
  private crossRegionMenuCenter = [0, 0];
  private crossRegionMenuWatchHandle!: __esri.WatchHandle;

  private hideRegionCrossMenu() {
    this.showCrossRegionMenu = false;
    if (this.crossRegionMenuWatchHandle) {
      this.crossRegionMenuWatchHandle.remove();
    }
  }

  @Emit("marker-click")
  public async showGisDeviceInfo(
    type: string,
    id: string,
    detail: any,
    label?: string
  ) {
    if (type === "region-cross") {
      this.hideRegionCrossMenu();
      // 等待一个tick，可以重新触发vue中的mounted
      await this.$nextTick();
      const point = detail.geometry;
      const screenPoint = this.mapApp.view.toScreen(point);
      this.crossRegionMenuCenter = [screenPoint.x, screenPoint.y];
      this.showCrossRegionMenu = true;
      this.crossRegionMenuWatchHandle = this.mapApp.view.watch("camera", () => {
        const screenPoint = this.mapApp.view.toScreen(point);
        this.crossRegionMenuCenter = [screenPoint.x, screenPoint.y];
      });
    }
  }

  @Emit("marker-mouse")
  public mouseGisDeviceInfo(
    event: any,
    type: string,
    id: string,
    detail: any
  ) {}

  // private crossInfoPanelWatchHandle: __esri.WatchHandle | undefined;
  @Emit("map-focused")
  public mapFocused(focusInfo: { type: string; id: string } | undefined) {
    // if (focusInfo?.type === "cross") {
    //   const checkPoint = checkPoints.find(
    //     (point) => point.type === "cross" && point.id === focusInfo.id
    //   );
    //   if (checkPoint?.panelPositions && checkPoint?.panelPositions.length > 0) {
    //     this.crossInfoPanelInfos = checkPoint?.panelPositions.map(
    //       (panelInfo) => {
    //         const screenPoint = this.mapApp.mapToScreen(
    //           panelInfo.position[0],
    //           panelInfo.position[1]
    //         );
    //         return {
    //           id: panelInfo.id,
    //           position: [screenPoint.x, screenPoint.y],
    //           videoUrl: panelInfo.videoUrl,
    //         };
    //       }
    //     );
    //     this.crossInfoPanelWatchHandle = this.mapApp.view.watch(
    //       "camera",
    //       () => {
    //         this.crossInfoPanelInfos = checkPoint?.panelPositions.map(
    //           (panelInfo) => {
    //             const screenPoint = this.mapApp.mapToScreen(
    //               panelInfo.position[0],
    //               panelInfo.position[1]
    //             );
    //             return {
    //               id: panelInfo.id,
    //               position: [screenPoint.x, screenPoint.y],
    //               videoUrl: panelInfo.videoUrl,
    //             };
    //           }
    //         );
    //       }
    //     );
    //   }
    // } else {
    //   if (this.crossInfoPanelWatchHandle) {
    //     this.crossInfoPanelInfos = [];
    //     this.crossInfoPanelWatchHandle.remove();
    //   }
    // }
  }

  @Emit("map-interactive")
  private mapInteractive(viewPoint: __esri.Viewpoint) {}

  @Emit("minimap-mouse-over")
  private onMinimapMouseOver() {}

  @Emit("minimap-mouse-out")
  private onMinimapMouseOut() {}

  @Emit("request-next-signal-phase")
  private requestNextSignalPhase(crossId: string) {}

  @Emit("phase-changed")
  private phaseChanged(crossId: string, phase: string) {}

  public async addOverlays(params: IOverlayParameter): Promise<IResult> {
    return await this.mapApp.addOverlays(params);
  }

  public async addHeatMap(params: IHeatParameter): Promise<IResult> {
    return this.mapApp.addHeatMap(params);
  }
  public async addOverlaysCluster(
    params: IOverlayClusterParameter
  ): Promise<IResult> {
    return await this.mapApp.addOverlaysCluster(params);
  }
  public deleteOverlays(params: IOverlayDelete): Promise<IResult> {
    return this.mapApp.deleteOverlays(params);
  }
  public deleteOverlaysCluster(params: IOverlayDelete) {
    this.mapApp.deleteOverlaysCluster(params);
  }
  public deleteAllOverlays() {
    this.mapApp.deleteAllOverlays();
  }
  public deleteAllOverlaysCluster() {
    this.mapApp.deleteAllOverlaysCluster();
  }
  public deleteHeatMap(params: ILayerConfig) {
    this.mapApp.deleteHeatMap(params);
  }
  public showLayer(params: ILayerConfig) {
    this.mapApp.showLayer(params);
  }
  public hideLayer(params: ILayerConfig) {
    this.mapApp.hideLayer(params);
  }
  public setMapCenter(params: IPointGeometry) {
    this.mapApp.setMapCenter(params);
  }
  public setMapViewpoint(viewpoint: __esri.Viewpoint) {
    this.mapApp.setMapViewpoint(viewpoint);
  }
  public async setMapCenterAndLevel(params: ICenterLevel): Promise<void> {
    await this.mapApp.setMapCenterAndLevel(params);
  }

  public setMapLevel(params: IMapLevel): Promise<void> {
    return this.mapApp.setMapLevel(params);
  }

  public async setMapCamera(params: ICamera) {
    await this.mapApp.setMapCamera(params);
  }
  public async setMapScaleFactor(factor: number) {
    await this.mapApp.setMapScaleFactor(factor);
  }
  public showJurisdiction() {}
  public hideJurisdiction() {}
  public showDistrictMask(param: IDistrictParameter) {}
  public hideDistrictMask() {}
  public findFeature(params: IFindParameter): Promise<IResult> {
    return this.mapApp.findFeature(params);
  }
  public showRoad() {}
  public hideRoad() {}
  public showStreet() {}
  public hideStreet() {}
  public locateStreet(param: IStreetParameter) {}
  public setMapStyle(param: string) {}
  public async routeSearch(params: IRouteParameter): Promise<IResult> {
    return { status: 0, message: "" };
  }
  public clearRouteSearch() {}
  public showRoutePoint(params: any) {}
  public clearRoutePoint() {}

  public async addDrawLayer(params: any): Promise<IResult> {
    return await this.mapApp.addDrawLayer(params);
  }
  public clearDrawLayer(params: any) {
    this.mapApp.clearDrawLayer(params);
  }
  public addHeatImage(params: IHeatImageParameter) {
    this.mapApp.addHeatImage(params);
  }
  public deleteHeatImage() {
    this.mapApp.deleteHeatImage();
  }
  public showMigrateChart(params: any) {
    this.mapApp.showMigrateChart(params);
  }
  public hideMigrateChart() {
    this.mapApp.hideMigrateChart();
  }
  public showBarChart(params: any) {
    this.mapApp.showBarChart(params);
  }
  public hideBarChart() {
    this.mapApp.hideBarChart();
  }
  public async startGeometrySearch(
    params: IGeometrySearchParameter
  ): Promise<IResult> {
    return await this.mapApp.startGeometrySearch(params);
  }
  public clearGeometrySearch() {
    this.mapApp.clearGeometrySearch();
  }
  public async showDgene(params: any): Promise<IResult> {
    return { status: 0, message: "" };
  }
  public hideDgene() {}
  public async addDgeneFusion(params: any): Promise<IResult> {
    return { status: 0, message: "" };
  }
  public async restoreDegeneFsion(): Promise<IResult> {
    return { status: 0, message: "" };
  }
  public showCustomTip(params: ICustomTip) {
    this.mapApp.showCustomTip(params);
  }
  public showDgeneOutPoint(params: any) {}
  public changeDgeneOut() {
    this.mapApp.changeDgeneOut();
  }

  public async initializeRouteSelect(params: ISelectRouteParam) {}
  public async showSelectedRoute(params: ISelectRouteResult) {}
  public async playSelectedRoute(speed: number) {}
  public stopPlaySelectedRoute() {}
  public async routeHitArea(params: ISelectRouteHitTest): Promise<IResult> {
    return { status: -1, message: "" };
  }
  public async areaHitRoute(params: ISelectRouteHitTest): Promise<IResult> {
    return { status: -1, message: "" };
  }

  public async startDrawOverlays(params: IDrawOverlays): Promise<void> {}
  public async stopDrawOverlays(): Promise<void> {}
  public async deleteDrawOverlays(params: IOverlayDelete): Promise<void> {}
  public async getDrawOverlays(): Promise<IResult> {
    return { status: 0, message: "" };
  }
  public async startLayerSearch(
    params: IGeometrySearchParameter
  ): Promise<IResult> {
    return { status: 0, message: "" };
  }
  public async startLayerDefinition(
    params: IDefinitionParameter
  ): Promise<void> {}

  public async startTrackPlay(params: ITrackParameter): Promise<void> {
    return await this.mapApp.startTrackPlay(params);
  }
  public async getOverlays(params: IOverlayDelete): Promise<IResult> {
    return { status: 0, message: "" };
  }
  public async getRegionOverlays(params: IOverlayParameter): Promise<IResult> {
    return { status: 0, message: "" };
  }

  public async connectSumoSimulation(
    params: ISumoConnectInfo
  ): Promise<IResult> {
    return await this.mapApp.connectSumoSimulation(params);
  }

  public disconnectSumoSimulation() {
    this.mapApp.disconnectSumoSimulation();
  }

  public async connectRealTimeSimulation(
    params: ISumoConnectInfo
  ): Promise<IResult> {
    return await this.mapApp.connectRealTimeSimulation(params);
  }

  public disconnectRealTimeSimulation() {
    this.mapApp.disconnectRealTimeSimulation();
  }

  public async toggleWatchMapFocus(params: { types: string[] }) {
    this.mapApp.toggleWatchMapFocus(params);
  }
  public async startWatchMapFocus() {
    await this.mapApp.startWatchMapFocus();
  }

  public stopWatchMapFocus() {
    this.mapApp.stopWatchMapFocus();
  }

  public startWatchMapCenter() {
    this.mapApp.startWatchMapCenter();
  }

  public stopWatchMapCenter() {
    this.mapApp.stopWatchMapCenter();
  }

  public setMapFocus(focusInfo: {
    type: string;
    id: string;
    scaleFactor?: number;
    highlightOpt?: any;
  }): Promise<IResult> {
    return this.mapApp.setMapFocus(focusInfo);
  }
  public async addMiniMapPoints(params: IOverlayParameter): Promise<IResult> {
    if (this.miniMap) {
      params.miniMapView = this.miniMap.miniMapView;
    }
    return this.mapApp.addMiniMapPoints(params);
  }

  public async initPassageWall(params: { roadUrl: string }): Promise<IResult> {
    return await this.mapApp.initPassageWall(params);
  }

  public async addPassageWall(params: IPassagewaysParam): Promise<void> {
    return this.mapApp.addPassageWall(params);
  }

  public async deletePassageWall() {
    return this.mapApp.deletePassageWall();
  }

  public async addAnimatePoints(params: IOverlayParameter): Promise<IResult> {
    if (params.showInMiniMap && this.miniMap) {
      params.miniMapView = this.miniMap.miniMapView;
    }
    return this.mapApp.addAnimatePoints(params);
  }

  public async deleteAnimatePoints(params?: IOverlayDelete): Promise<IResult> {
    if (this.miniMap) {
      if (params) {
        params.miniMapView = this.miniMap.miniMapView;
      } else {
        params = { miniMapView: this.miniMap.miniMapView };
      }
    }
    return this.mapApp.deleteAnimatePoints(params);
  }

  public async startSignalPhase(params: ISignalPhaseInfo): Promise<IResult> {
    return this.mapApp.startSignalPhase(params);
  }

  public async startDrawCrossRegion(params?: {
    tool?: string;
  }): Promise<IResult> {
    this.hideRegionCrossMenu();

    return this.mapApp.startDrawCrossRegion(params);
  }

  public stopDrawCrossRegion() {
    this.mapApp.stopDrawCrossRegion();
  }

  public startDeleteCrossRegion(): Promise<IResult> {
    this.hideRegionCrossMenu();

    return this.mapApp.startDeleteCrossRegion();
  }

  public stopDeleteCrossRegion() {
    this.mapApp.stopDeleteCrossRegion();
  }

  public showCrossRegions(params: { regions: Array<ICrossRegionInfo> }) {
    this.mapApp.showCrossRegions(params);
  }

  public hideCrossRegions() {
    this.hideRegionCrossMenu();

    this.mapApp.hideCrossRegions();
  }

  public toggleBuildingLayer(visible: boolean) {
    this.mapApp.toggleBuildingLayer(visible);
  }
  public async showPopup(params: IPopUpTemplate) {
    this.mapApp.showPopup(params);
  }
  public closePopup() {
    this.mapApp.closePopup();
  }
  public toggleWidget(params: string[]) {
    let widgets = params;
    let self = this;
    widgets.forEach((widgetName: string) => {
      //如果存在,则隐藏

      let index = this.showWidgets.indexOf(widgetName);
      if (index > -1) {
        this.showWidgets.splice(index, 1);
      } else {
        this.showWidgets.push(widgetName);
      }
    }, this);
  }
  public setMinimapPosition(params: IPosition) {
    if (this.miniMap) {
      (this.miniMap.$el as any).style.left = params.left ? params.left : "";
      (this.miniMap.$el as any).style.right = params.right ? params.right : "";
      (this.miniMap.$el as any).style.bottom = params.bottom
        ? params.bottom
        : "";
      (this.miniMap.$el as any).style.top = params.top ? params.top : "";
    }
  }

  public queryCrossInView(params: ICrossInView): IResult {
    return this.mapApp.queryCrossInView(params);
  }

  public toggleLayerByYear(year: string) {
    this.mapApp.toggleLayerByYear(year);
  }

  public setCrossCamera(params: ICrossCamera) {
    this.mapApp.setCrossCamera(params);
  }

  public clearCrossCamera() {
    this.mapApp.clearCrossCamera();
  }

  public initializeLaneSignalPhase(crossId: string) {
    return this.mapApp.initializeLaneSignalPhase(crossId);
  }

  public startLaneSignalPhase(laneSignalPhaseInfos: ILaneSignalPhaseInfo[]) {
    return this.mapApp.startLaneSignalPhase(laneSignalPhaseInfos);
  }

  public stopLaneSignalPhase(crossId: string) {
    return this.mapApp.stopLaneSignalPhase(crossId);
  }

  public stopAllLaneSignalPhase() {
    return this.mapApp.stopAllLaneSignalPhase();
  }

  public async selectLane_initialize() {
    return this.mapApp.selectLane_initialize();
  }

  public selectLane_getResult(): IResult {
    return this.mapApp.selectLane_getResult();
  }

  public selectLane_showLanes(params: IShowSelectedLaneParam[]): void {
    this.mapApp.selectLane_showLanes(params);
  }

  public async addComponentOverlay(
    params: IComponentOverlayParam
  ): Promise<IResult> {
    return await this.mapApp.addComponentOverlay(params);
  }

  public deleteComponentOverlay(params?: IOverlayDelete) {
    return this.mapApp.deleteComponentOverlay(params);
  }

  public async dynamicLayer_initialize(configFile: string) {
    await this.mapApp.dynamicLayer_initialize(configFile);
  }

  public async dynamicLayer_show(params: IDynamicLayerDataParams) {
    await this.mapApp.dynamicLayer_show(params);
  }

  public dynamicLayer_hide(params: IDynamicLayerDataParams) {
    this.mapApp.dynamicLayer_hide(params);
  }
}
